import React from 'react';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface DateLineProps {
  date?: Date | undefined;
  isMarginTop?: boolean;
}

const DateLine = ({ date, isMarginTop }: DateLineProps) => {
  if (!date) return null;

  const text = DateFormat.format(date, 'yyyy.MM.dd (week)');

  return (
    <li className={cx('dateLineArea', { marginTop: isMarginTop })}>
      <div className={cx('divider')} />
      <div className={cx('date')}>{text}</div>
      <div className={cx('divider')} />
    </li>
  );
};

export default DateLine;
